const lastNameRules = [
  {
    feedback: 'Last name is required',
    test(value) {
      return !!value;
    },
  },
];

export default lastNameRules;
